import { useQuery } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { fetchTheses, type ApiThesis } from '../../lib/api'
import { Page } from '../../components/layout/AppShell'
import { PageHeader } from '../../components/layout/PageHeader'
import { Badge, Panel, Spinner, ErrorState, Table, type Column } from '../../components/ui'
import { fmtDateTime } from '../../lib/format'
import { thesisTitle, statusTone, statusLabel } from './thesisShared'

export function ThesesListPage() {
  const navigate = useNavigate()
  const { data, isLoading, isError } = useQuery({ queryKey: ['theses'], queryFn: fetchTheses })

  const columns: Column<ApiThesis>[] = [
    { key: 'name', header: 'Thesis', render: (t) => <span className="font-medium">{thesisTitle(t)}</span> },
    { key: 'status', header: 'Status', render: (t) => <Badge tone={statusTone(t.status)}>{statusLabel(t.status)}</Badge> },
    { key: 'mode', header: 'Mode', render: (t) => <span className="text-text-muted">{t.trading_mode}</span> },
    {
      key: 'paper',
      header: 'Paper',
      render: (t) =>
        t.graduated_at ? (
          <Badge tone={t.status === 'killed' ? 'neutral' : 'green'}>{t.status === 'killed' ? 'finished' : 'live'}</Badge>
        ) : (
          <span className="text-text-muted">—</span>
        ),
    },
    { key: 'created', header: 'Created', render: (t) => fmtDateTime(t.created_at) },
  ]

  return (
    <Page width="wide" header={<PageHeader crumbs={[{ label: 'Theses' }]} />}>
      <Panel>
        {isLoading ? (
          <Spinner />
        ) : isError ? (
          <ErrorState />
        ) : (
          <Table
            columns={columns}
            rows={data ?? []}
            empty="No theses yet."
            onRowClick={(t) => navigate({ to: '/theses/$thesisId', params: { thesisId: t.id } })}
          />
        )}
      </Panel>
    </Page>
  )
}
